import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ComponentType } from '@vgtv/api-client/lib/component';

import { Overlay } from '../Overlay/Overlay';
import { AssetsFilteredList } from '../PageComponents/components/AssetsFilteredList/AssetsFilteredList';
import { usePreviousValue } from '../utils/usePreviousValue';

import type { FilteredListComponent } from '@vgtv/api-client/lib/component/filtered_list';
import type { FC } from 'react';

import * as styles from './SearchPopup.module.scss';

interface SearchPopupProps {
  isOpen: boolean;
  close: () => void;
}

const syntheticComponent: Pick<
  FilteredListComponent,
  'type' | 'header' | 'categoryId' | 'options' | 'filters'
> = {
  type: ComponentType.FILTERED_LIST,
  options: {} as FilteredListComponent['options'],
  filters: [],
};

const SearchPopup: FC<SearchPopupProps> = ({ isOpen, close }) => {
  const inputRef = useRef<HTMLInputElement>(null!);
  const location = useLocation();
  const previousLocation = usePreviousValue(location);

  // close the popup when a video has been clicked
  useEffect(() => {
    if (location.pathname !== previousLocation.pathname) {
      close();
    }
  }, [close, location, previousLocation]);

  useEffect(() => {
    if (isOpen) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  return (
    <Overlay
      onCloseButtonClick={close}
      isOpen={isOpen}
      type="overlay/popup"
      forceRender // must be pre-rendered so that programmatic focus works on iOS
      contentClassName={styles.container}
    >
      <AssetsFilteredList
        searchInputRef={inputRef}
        key={isOpen as unknown as React.Key}
        componentConfig={syntheticComponent}
      />
    </Overlay>
  );
};

export { SearchPopup };
